const scope_0 = require('/opt/render/project/src/.cache/gatsby-mdx/mdx-scopes-dir/22af102715035727c112fa7146518f42.js').default;
const scope_1 = require('/opt/render/project/src/.cache/gatsby-mdx/mdx-scopes-dir/299b98a0e77da0e039fd006f3138681a.js').default;
const scope_2 = require('/opt/render/project/src/.cache/gatsby-mdx/mdx-scopes-dir/30905178e96b3ab2f91545c2ae4d34d1.js').default;
const scope_3 = require('/opt/render/project/src/.cache/gatsby-mdx/mdx-scopes-dir/5a32af4b4bcbbab79f721e1f81f1b538.js').default;
const scope_4 = require('/opt/render/project/src/.cache/gatsby-mdx/mdx-scopes-dir/925627ed65800d227540963eb91a05b0.js').default;
const scope_5 = require('/opt/render/project/src/.cache/gatsby-mdx/mdx-scopes-dir/e43fb7ea8e5c973fc291302acf6043f3.js').default;export default 
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    